import React from 'react'
import './FormInput.css'

const FormInput = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  required = false,
  disabled = false,
  rows,
  ...props
}) => {
  const InputComponent = type === 'textarea' ? 'textarea' : 'input'
  
  return (
    <div className="form-input-group">
      {label && (
        <label htmlFor={name} className="form-input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <InputComponent
        type={type === 'textarea' ? undefined : type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        className={`form-input ${type === 'textarea' ? 'form-textarea' : ''} ${error ? 'error' : ''}`}
        {...props}
      />
      {error && <span className="form-input-error">{error}</span>}
    </div>
  )
}

export default FormInput

